module.exports = __webpack_public_path__ + "static/media/arrowClick.e862c96a.svg";